module.exports = __webpack_public_path__ + "/images/cover-cta-hamaca-babybjorn.12ff84e.jpg";